import { Text } from '@chakra-ui/react';

import asBentoPage from 'common/bento/hoc/asBentoPage';
import Heading from 'components/_core/Heading';
import ApplicationProblemImage from 'features/Onboarding/components/ApplicationProblemImage';
import OBNavigation from 'features/Onboarding/components/OBNavigation/OBNavigation';

import locales from './locales';

const Ineligible = asBentoPage(({ Layout }) => (
  <Layout data-testid="company-ineligible" nav={<OBNavigation />}>
    <ApplicationProblemImage />

    <Heading marginBottom="space-16" size="lg">
      {locales.title}
    </Heading>

    <Text marginBottom="space-32" variant="primary">
      {locales.description}
    </Text>
  </Layout>
));

export default Ineligible;
